var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotValidatedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.175 13.75C25.6 8.5375 21.4625 4.4 16.25 3.825V1.25H13.75V3.825C12.525 3.9625 11.3625 4.3 10.2875 4.8L12.2 6.7125C13.075 6.4125 14.025 6.25 15 6.25C19.8375 6.25 23.75 10.1625 23.75 15C23.75 15.9875 23.5875 16.925 23.2875 17.8L25.2 19.7125C25.7 18.6375 26.0375 17.475 26.175 16.25H28.75V13.75H26.175ZM3.75 5.3375L6.3 7.8875C4.9625 9.525 4.075 11.5375 3.825 13.75H1.25V16.25H3.825C4.4 21.4625 8.5375 25.6 13.75 26.175V28.75H16.25V26.175C18.4625 25.925 20.475 25.0375 22.1125 23.7L24.6625 26.25L26.425 24.4875L5.5125 3.575L3.75 5.3375ZM20.3375 21.925C18.8625 23.0625 17.0125 23.75 15 23.75C10.1625 23.75 6.25 19.8375 6.25 15C6.25 12.9875 6.9375 11.1375 8.075 9.6625L20.3375 21.925Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotValidatedLocation);
export default __webpack_public_path__ + "static/media/not_validated_location.c97a0b62f660d6735b77f8df92c51932.svg";
export { ForwardRef as ReactComponent };